<template>
	<div>

		<div v-if="library">
			<b-button v-b-toggle="'collapse-doc'">Document</b-button><br /><br />

			<b-collapse id="collapse-doc">
				<documents
					:select="true"
					:download="false"
					:select_view="false"
					:ref="'doc'"
					@add_file="set_document_ged"></documents>
			</b-collapse>
		</div>

		<b-form inline>
			<b-input-group v-if="!library && types.length > 0" prepend="Type">
				<b-select @change="change_type" v-model="type" :options="types"></b-select>
			</b-input-group>
			<b-input-group prepend="Page">
				<b-select
					v-model="page"
					:options="documents_page"
				></b-select>
			</b-input-group>
		</b-form>

		<vue-pdf-embed
			v-show="false"
			@loaded="loaded"
			@rendered="rendered"
			:id="'pdf' + id"
			v-if="document" 
			style="border: solid; "
			:ref="'pdf' + id"
			:page="page"
			:source="document"
			:scale=1 />

		<b-container
			style="
				margin: 0px !important;
				padding: 0px !important;
				max-width: none !important;
			">
			<b-row>
				<b-col cols="8">
					<div ref="panzoomElem">
						<panZoom
							selector=".movable"
							style="border: 1px solid; overflow: hidden"
							:options="{
								initialZoom: 1,
								bounds: false,
							}"
							@init="onInit">
							<div
								style="height: 500px; width: 2000px"
								@mousemove="handler_move($event)"
								@mouseup.right="handler_up($event)"
								@mousedown.right="handler($event)"
								@contextmenu.prevent>
								<div class="movable">
									<img
										v-if="image && view_image == 'oui'"
										:src="
											image
										" /><img />
									<div
										:style="
											'position:fixed; top:' +
											abs_y +
											'px; left:' +
											(abs_x - 5) +
											'px; height: 1px; width: 11px; background-color: red;'
										"></div>
									<div
										:style="
											'position:fixed; top:' +
											(abs_y - 5) +
											'px; left:' +
											abs_x +
											'px; height: 11px; width: 1px; background-color: red;'
										"></div>
									<div v-for="(zone, idx) in zones" :key="idx">
										<div v-if="zone.page == page"
											:style="
												'position:fixed; top:' +
												zone.y +
												'px; left:' +
												zone.x +
												'px; width: ' +
												zone.width +
												'px; height: ' +
												zone.height +
												'px; background-color: ' + (idx == select ? 'rgb(255,0,0,0.25)' : 'rgb(0,0,255,0.25)') + ';'
											">
											<p><b>Signature {{idx + 1}}</b></p>
										</div>
									</div>
								</div>
							</div>
						</panZoom>
						<br />
						<b-button @click="reset">Recadrer la vue</b-button>
					</div>
				</b-col>
				<b-col cols="4">
					<h3>Coordonnées</h3>
					<div>
						Coordonnées actuelles<br />
						X : {{ actual_x }} - Y : {{ actual_y }}
					</div>
					<div>
						Coordonnées ciblées<br />
						X : {{ x }} - Y : {{ y }}
					</div>
					<div>
						<h3>Signatures</h3>						
						<div v-for="(zone, idx) in zones" :key="idx">
							<p><span :style="'font-weight:' + (idx == select ? 'bold' : 'normal')">Signature {{ idx + 1 }}, page {{zone.page}}</span> <b-button @click="change_select(idx)" variant="link"><i class="fas fa-eye"></i></b-button><b-button @click="del(idx)" variant="link"><i class="fas fa-trash"></i></b-button></p>
						</div>
						<b-button variant="link" @click="add"><i class="fas fa-plus"></i></b-button>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";
	import { JSONEditor } from "@json-editor/json-editor";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";
	import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

	import store from "../store";
	import library from "../services/library.js";
	import workers from "../services/workers.js";
	import documents from "../views/Document.vue";
	import treatments from "../services/treatments.js";
	import document_service from "../services/document.js";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import document_extraction_zone from "../components/document_extraction_zone.vue";
	import document_extraction_tree from "../components/document_extraction_tree.vue";

	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	export default {
		name: "document_extraction_zones",
		components: {
			draggable,
			FadeLoader,
			edit_tabulator,
			VuePdfEmbed,
			documents
		},
		props: {
			library: {
				default: false
			},
			type_doc: {
				default: ""
			}
		},
		data() {
			return {
				id: uniqueId(""),
				relative: false,
				move: false,
				name_zone: "",
				color: "oui",
				view_image: "oui",
				view_text: "oui",
				spinner: false,
				results: {},
				name: "",
				page: 1,
				url_pdf: "",
				url_image: "",
				image: "",
				panzoomInstance: null,
				items: [],
				styles: {},
				target: -1,
				item: null,
				x: 0,
				actual_x: 0,
				y: 0,
				actual_y: 0,
				abs_x: 0,
				abs_actual_x: 0,
				abs_y: 0,
				abs_actual_y: 0,
				e: null,
				zones: [
				],
				zone: null,
				view_zones: "",
				document: {},
				document_page: "",

				document: null,
				documents_page: [],

				select: -1,
				doc_ged: null,

				type: "",
				types: []
			};
		},
		watch: {
		},
		methods: {
			async set_document_ged(doc)
			{
				this.doc_ged = doc;

				doc = await document_service.getFile(doc.uid, doc.libelle, false, "blob", doc.share);
				await this.setDocument(doc);

				if (this.type_doc && this.doc_ged[this.type_doc])
				{
					if (this.types.includes(this.doc_ged[this.type_doc]))
					{
						this.type = this.doc_ged[this.type_doc];
						this.change_type(this.doc_ged[this.type_doc]);
					}
				}
			},
			async load(data)
			{
				console.log(data)
				this.zones = data.zones;
				this.doc_ged = data.doc;

				if (this.doc_ged && this.library)
					this.set_document_ged(this.doc_ged);
			},
			async save()
			{
				return {
					zones: this.zones,
					doc: this.doc_ged,
					data: this.get_data()
				}
			},
			async new() {
			},
			get_data()
			{
				var data = [];

				for (var i = 0; i < this.zones.length; i++)
				{
					var zone = {};
					zone.positionX = this.zones[i].x;
					zone.positionY = this.zones[i].image_height - (this.zones[i].y + this.zones[i].height);
					zone.page = this.zones[i].page;
					zone.order = i + 1;
					zone.withoutLogo = true;

					data.push(zone);
				}

				data = { signFields : data}

				return data;
			},
			change_select(idx)
			{
				this.select = idx;
			},
			add()
			{
				this.zones.push({
					uid: uniqueId(""),
					x: 0,
					y: 0,
					width: 200,
					height: 60,
					page: this.page,
					image_width: this.image_width,
					image_height: this.image_height
				})

				this.select = this.zones.length - 1;
			},
            del(idx)
            {
				this.zones.splice(idx, 1);
				
				if (this.select >= this.zones.length)
					this.select = this.zones.length - 1;
            },
			loaded(data)
			{
				console.log(data._pdfInfo.numPages)

				this.documents_page = [];
				for (var i = 0; i < data._pdfInfo.numPages; i++)
				{
					this.documents_page.push(i + 1)
				}

			},
			rendered()
			{
				var self = this;
				let s = document.querySelectorAll('#pdf' + this.id + ' canvas')[0]
				console.log(s)

				this.image = s.toDataURL('img/png');

				var i = new Image();

				i.onload = function(){
					self.image_width = i.width;
					self.image_height = i.height;
				};

				i.src = this.image;
			},
			_arrayBufferToBase64(buffer) {
				var binary = "";
				var bytes = new Uint8Array(buffer);
				var len = bytes.byteLength;
				for (var i = 0; i < len; i++) {
					binary += String.fromCharCode(bytes[i]);
				}
				return window.btoa(binary);
			},
			setDocument: async function (document) {

				if (document)
				{
					var self = this;
					let reader = new FileReader();

					reader.onload = function(e) {
						self.document = new Uint8Array(reader.result);
						console.log(self.document);
					}

					reader.readAsArrayBuffer(document);
				}
			},
			addClass: function (e) {
				this.target = e.target.id;
				e.target.classList.add("hovered");
			},
			removeClass: function (e) {
				this.target = -1;
				e.target.classList.remove("hovered");
			},
			setMeta(name, page, url_pdf) {
				this.name = name;
				this.page = page;
				this.url_pdf = url_pdf;
			},
			setItems(items) {
				this.items = items;
			},
			setStyle(styles) {
				this.styles = styles;
			},
			reset() {
				this.panzoomInstance.zoomAbs(0, 0, 1);
				this.panzoomInstance.moveTo(0, 0);
			},
			onInit: function (panzoomInstance, id) {
				this.panzoomInstance = panzoomInstance;
				//this.panzoomInstance.zoomTo(0, 0, 2);
			},
			handler_up: function (e) {
			},
			handler_move: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				this.actual_x = Math.round(left);
				this.abs_actual_x = this.actual_x;
				if (this.relative && this.zone.position_parent)
					this.actual_x -= this.zone.position_parent.left;
				this.actual_y = Math.round(top);
				this.abs_actual_y = this.actual_y;
				if (this.relative && this.zone.position_parent)
					this.actual_y -= this.zone.position_parent.top;
			},
			handler: function (e) {
				var left =
					e.clientX -
					this.$refs.panzoomElem.getBoundingClientRect().left;
				var top =
					e.clientY -
					this.$refs.panzoomElem.getBoundingClientRect().top;
				var pos = this.panzoomInstance.getTransform();
				left = (left / pos.scale - pos.x / pos.scale) * 1;
				top = (top / pos.scale - pos.y / pos.scale) * 1;
				this.x = Math.round(left);
				this.abs_x = this.x;
				if (this.relative && this.zone.position_parent)
					this.x -= this.zone.position_parent.left;
				this.y = Math.round(top);
				this.abs_y = this.y;
				if (this.relative && this.zone.position_parent)
					this.y -= this.zone.position_parent.top;
				if (this.e) this.e.target.classList.remove("selected");
				if (this.target > -1) {
					this.item = this.items[this.target];
					this.e = e;
					e.target.classList.add("selected");
				} else {
					this.e = null;
					this.item = null;
				}

				this.move = true;

				if (this.select > -1)
				{
					this.zones[this.select].x = this.x;
					this.zones[this.select].y = this.y;
					this.zones[this.select].page = this.page;
					this.zones[this.select].image_width = this.image_width;
					this.zones[this.select].image_height = this.image_height;
				}
			},
			async change_type(type)
			{
				console.log("change_type")
				var data = await library.getby_production("document_zone", type, true);
				console.log(data);
				this.load(data);
			}
		},
		mounted: async function () {
			if (!this.library)
			{
				var list = await library.getby_production("document_zone");
				
				for (var i = 0; i < list.element.length; i++)
				{
					this.types.push(list.element[i].name)
				}
			}
		},
	};
</script>

<style>
	.hovered {
		text-decoration: underline blue;
		cursor: crosshair;
	}
	.selected {
		text-decoration: underline red;
		cursor: crosshair;
	}
</style>
